import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewRequests = (filters) =>
  useQuery({
    queryKey: riskReviewKeys.requestList(filters),
    queryFn: () => riskReviewService.getRequests(filters),
    keepPreviousData: true,
    staleTime: 15000,
  });
